import React from 'react'
import PropTypes from 'prop-types'
import Modal from 'react-modal'
import {hideModal, CREATE_DIALOG} from '../../modules/modals'
import { connect } from 'react-redux'
import CreateDialogForm from './CreateDialogForm'


const CreateDialogModal = (props, context) => {
    let {hideModal, zIndex, onLoaded} = props
    const {formatMessage} = context
    const handleClose = () => hideModal({ modalType : CREATE_DIALOG})
    return (
        <Modal
            isOpen = {true}
            style = {{
                overlay : {zIndex},
            }}
            onRequestClose={handleClose}
            overlayClassName = "custom-modal"
            className = "custom-modal-content create-dialog-modal-content"
        >
            <div className="create-dialog-modal-content__header">
                <div className="create-dialog-modal-content__title">{formatMessage("Create a request")}</div>
                <div
                    onClick={handleClose}
                    className="create-dialog-modal-content__close"
                ></div>
            </div>
            <div className="create-dialog-modal-content__body">
                <CreateDialogForm onLoaded={onLoaded} />
            </div>
        </Modal>
    )
}
CreateDialogModal.contextTypes = {formatMessage: PropTypes.any}

export default connect(
    null,
    {hideModal}
)(CreateDialogModal)


// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/Support/CreateDialogModal.js